<template>
  <div
    class="boss-message-box boss-message-box-received"
    :class="{'boss-message-box-can-send':canSendMessage}"
  >
    <img
      src="@/assets/images/boss-avatar.svg"
      class="boss-message-box-avatar boss-message-box-avatar-user"
    >
    <entry-message-history-message-detail
      :date="date"
      :subject="subject"
      :body="body"
    />
    <div
      v-if="canSendMessage"
      class="boss-message-last-button-block"
    >
      <button
        v-tooltip="tooltip"
        href="javascript:void(0)"
        class="boss-button pega-button"
        data-test="quote-message"
        :disabled="isReserved || isWithdraw"
        @click="setMessage"
      >
        メッセージを引用してメールを作成
      </button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import EntryMessageHistoryMessageDetail from '@/components/molecules/EntryMessageHistoryMessageDetail'

export default {
  components: {
    EntryMessageHistoryMessageDetail
  },
  props: {
    body: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    subject: {
      type: String,
      default: ''
    },
    isReserved: {
      type: Boolean,
      default: false
    },
    isWithdraw: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'canSendMessage'
    ]),
    tooltip () {
      return this.isReserved ? { content: 'メッセージ予約中のためメールを作成できません。' } : undefined
    }
  },
  methods: {
    setMessage () {
      if (this.isReserved || this.isWithdraw) return // 予約中または退会している場合は処理skip
      this.$emit('setMessage', { message: { body: '>' + _.replace(this.body, /\r?\n/g, '\n>'), subject: this.subject } })
    }
  }
}
</script>
